import { connect } from 'react-redux';
import { IState } from '../../../reducers';
import { CookieBanner } from './cookieBanner';

import { withCookies } from 'react-cookie';
import { setCookieBannerVisibilityAction } from './actions/setCookieBannerVisibility';

const mapStateToProps = (state: IState) => ({
    showCookieBanner: state.mainContent.cookieBannerVisible
});

const mapDispatchToProps = (dispatch: any) => ({
    setCookieBannerVisibility: (isVisible: boolean) => dispatch(setCookieBannerVisibilityAction(isVisible)),
});

export const CookieBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withCookies(CookieBanner));


// WEBPACK FOOTER //
// ./src/common/components/cookieBanner/cookieBannerContainer.tsx